/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="37px" height="38px" viewBox="0 0 37 38" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
    <title>Close</title>
    <g id="Page-1" stroke="none" fill="none" fillRule="evenodd" strokeWidth="1">
        <g id="DisabilityInsurancePage_FAQExpanded" transform="translate(-1056.000000, -1812.000000)">
            <g id="FAQ_Drawer_Expanded" transform="translate(321.500000, 1708.775168)">
                <g id="FAQ-1" transform="translate(0.000000, 76.000000)">
                    <g id="Close" transform="translate(735.000000, 28.000000)">
                        <circle id="Oval" fill="#1570BC" cx="18.144" cy="18.144" r="18.144"/>
                        <line x1="25.426333" y1="17.7001733" x2="11.1001966" y2="17.7001733" id="Line-3" stroke="#FFFFFF" strokeWidth="3.456" strokeLinecap="square"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
    );
  }
}

Icon.displayName = 'ButtonMinusIcon';

export default Icon;
